// extracted by mini-css-extract-plugin
export default {"root":"GiftPromocodeModal__root--3LtiK","title":"GiftPromocodeModal__title--1zoRI","root_newYear":"GiftPromocodeModal__root_newYear--1oYyM"};